import { ValueObject } from '@/domain/valueObject';

/**
 * コンテンツ添付プロパティ
 */
export interface ContentAttachmentProps {
  /** コンテンツ */
  content: string,
  /** 名前 */
  name: string,
}

/**
 * コンテンツアタッチメント
 */
export class ContentAttachment extends ValueObject<ContentAttachmentProps> {
  /**
   * 生成する
   * @param props プロパティ
   * @returns 値
   */
  static create(props: ContentAttachmentProps): ContentAttachment {
    return new ContentAttachment(props);
  }

  /**
   * コンテンツ
   */
  get content(): string {
    return this.val.content;
  }

  /**
   * 名前
   */
  get name(): string {
    return this.val.name;
  }
}
